import { STEPS } from '@zatopek/funnel/src/utils/constants'

export const mapEmergyaAddress = (emergyaAddress, step) => {
  const {
    niceAddress,
    cupsID,
    gasCupsID,
    id,
    postCode,
    province,
    town,
    roadType,
    roadTypeName,
    road,
    building,
    staircase,
    label,
    normalisedRoadID,
    placeID,
    origin,
    ...rest
  } = emergyaAddress

  return step === STEPS.billing
    ? {
        addressLine: niceAddress,
        electricityCups: cupsID,
        gasCups: gasCupsID,
        externalId: id,
        postalCode: postCode,
        province,
        city: town,
        streetType: roadTypeName,
        street: road,
        portal: building,
        stair: staircase,
        placeId: placeID,
        origin,
        ...rest,
      }
    : {
        addressLine: niceAddress || label,
        electricityCups: cupsID,
        gasCups: gasCupsID,
        externalId: String(normalisedRoadID) || '',
        postalCode: postCode,
        provinceName: province,
        municipalityName: town,
        streetType: roadTypeName,
        streetName: road,
        portal: building,
        stair: staircase,
        placeId: placeID,
        origin,
        ...rest,
      }
}

export default mapEmergyaAddress
